@import '../../styles/host.css';

:host {
    display: block;
}

.protean-option-container {
    display: flex;
    min-height: 42px;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
}

:host([active]) .protean-option-container,
.protean-option-container:hover,
.protean-option-container:focus {
    background-color: var(--protean-dropdown-hover-background-color, #353535);
    color: var(--protean-dropdown-hover-text-color, inherit);
}

[aria-disabled='true'] {
    opacity: 0.4;
    cursor: not-allowed;
}

.protean-option-selected {
    padding: 0 5px;
    flex: 0 0 34px;
}

.protean-option-content {
    flex: 0 1 auto;
}
